var l = /* @__PURE__ */ ((e) => (e.CALL = "call", e.SEND = "send", e))(l || {});
export {
  l as ContractOperation
};
//# sourceMappingURL=contract.js.map
